import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'mask'
})
export class MaskPipe implements PipeTransform {

  transform(value: string, visibleDigits: number = 3, type: string = 'default'): string {
    if(!value) return '';

    let startVisible = '';
    let endVisible = '';
    let maskedPart = '';
    switch(type) {
      case 'name': // 周*倫 王*
        startVisible = value.slice(0, visibleDigits); // 開頭顯示的位數
        if(value.length === 2) {
          maskedPart = '*'.repeat(value.length - 1); // 隱碼部分
        }else if(value.length <= 5) {
          maskedPart = '*'.repeat(value.length - 2); // 隱碼部分
          endVisible = value.slice(-visibleDigits); // 結尾顯示的位數
        }else {
          maskedPart = '*'.repeat(value.length - 2 * visibleDigits); // 中間隱碼部分
          endVisible = value.slice(-visibleDigits); // 結尾顯示的位數
        }
        break;
      case 'id': // A123***123
        startVisible = value.slice(0, visibleDigits); // 開頭顯示的位數
        maskedPart = '*'.repeat(visibleDigits - 1); // 中間隱碼部分
        endVisible = value.slice(-visibleDigits + 1); // 結尾顯示的位數
        break;
      case 'birthday': // 1991/**/15
        startVisible = value.slice(0, visibleDigits); // 開頭顯示的位數
        maskedPart = '*'.repeat(2); // 中間隱碼部分
        endVisible = value.slice(-3); // 結尾顯示的位數
        break;
      case 'birthdayROC': // 民國 94 年 ** 月 1 日
        startVisible = value.slice(0, visibleDigits); // 開頭顯示的位數
        maskedPart = '*'.repeat(2); // 中間隱碼部分
        endVisible = value.slice(-6); // 結尾顯示的位數
        break;
      case 'birthdayROC2': // 080/**/01
        startVisible = value.slice(0, visibleDigits); // 開頭顯示的位數
        maskedPart = '*'.repeat(2); // 中間隱碼部分
        endVisible = value.slice(-3); // 結尾顯示的位數
        break;
      default:
        return value;
    }

    return startVisible + maskedPart + endVisible;
  }

}
